import { useEffect } from 'react';

import { logError } from 'utils/log';
import { getItem, removeItem, setItem } from 'utils/storage/localStorage';

type Props = {
  profileId: number,
  campaignId: number,
  message: string,
  onUnsentMessage: (a: string) => void
};

const UnsentMessagesStorage = ({
  profileId,
  campaignId,
  message,
  onUnsentMessage
}: Props) => {
  const key = `collabary/unsent-message/${profileId}/${campaignId}`;
  const stringToHash = typeof window.btoa === 'function' ? window.btoa : str => str;
  const hashToString = typeof window.atob === 'function' ? window.atob : str => str;

  // Get unsent message
  useEffect(() => {
    try {
      const unsentMessage = hashToString(getItem(key) || '');

      onUnsentMessage(unsentMessage);
    } catch (error) {
      logError(error);
    }
  }, [profileId, campaignId]);

  // Save/update/remove message
  useEffect(() => {
    try {
      if (message.trim().length === 0) {
        removeItem(key);
      } else {
        setItem(key, stringToHash(message));
      }
    } catch (error) {
      logError(error);
    }
  }, [message]);

  return null;
};

export default UnsentMessagesStorage;
